import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ExercisesProvider } from "./contexts/exercises/exersices.contexts";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ExercisesProvider>
        <App />
      </ExercisesProvider>
    </BrowserRouter>
  </React.StrictMode>
);
